import Icon from "../ui/Icon";

export default function PageHeader({ title, onBack, backDisabled = false }) {
  return (
    <div className="flex items-center gap-3 pt-4 pb-2">
      <button
        type="button"
        onClick={onBack}
        disabled={backDisabled}
        className={`flex h-9 w-9 items-center justify-center rounded-full bg-brand-purple text-brand-light transition shrink-0 ${
          backDisabled ? "opacity-40 cursor-not-allowed" : "hover:bg-brand-purple/80"
        }`}
        aria-label="Back"
      >
        <Icon name="arrow_back" className="text-xl" />
      </button>
      <span className="text-lg font-black italic text-brand-light tracking-tight">{title}</span>
    </div>
  );
}
